module.exports = __webpack_public_path__ + "static/media/PRACTICA8.e99961cc.jpeg";